import { defaultTheme } from "react-admin";
import createMuiTheme from "@material-ui/core/styles/createMuiStrictModeTheme";
import merge from "lodash/merge";

export const myTheme = createMuiTheme(
  merge({}, defaultTheme, {
    palette: {
      /* primary: {
        main: '#01b5d0', // Colore principale, ad esempio è usato in automato da bottoni come EditButton
      }, */
      secondary: {
        main: "#e85a2c", // Colore principale

        /* DEV
        
        #9bdaed
        #082b51
        #e85a2c
        #10a1b4
        #ebf8fa
        
        
        */

      },
      // Nota: verifica il valore di "width" poiché 11140 potrebbe essere un errore
      RaSidebar: {
        sidebar: {
          width: 11140,
          closedWidth: 50,
        },
        fixed: {
          position: 'inherit'
        }
      },
    },
  })
);